import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { changeProdutoPredominante, clearError } from "../../../features/manifestoSlice";
import { MakeMessageError } from "../../../components/Components";
import { TypeCargaProdutoPredominante } from "../../../lists";

export default function ProdutoPredominante(props: any) {
    const formManifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const dispatch = useDispatch();

    const handleProdPred = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeProdutoPredominante({ [name]: value }));
        dispatch(clearError('prodPred_' + name))
    }

    return (<div className="px-2">
        <Row>
            <Col md={3}>
                <Form.Group className="mb-2">
                    <Form.Label>Tipo de carga</Form.Label>
                    <Form.Select name="tpcarga" value={formManifesto.prodPred.tpcarga}
                        onChange={handleProdPred}>
                            {TypeCargaProdutoPredominante.map(i => {
                                return (
                                    <option key={i.id} value={i.id}>{i.name}</option>
                                )
                            })}
                    </Form.Select>

                    <MakeMessageError errors={errors} field="prodPred_tpcarga" />
                </Form.Group>
            </Col>

            <Col md={2}>
                <Form.Group className="mb-2">
                    <Form.Label>CEAN</Form.Label>
                    <Form.Control type="text" maxLength={14} name="cean" value={formManifesto.prodPred.cean}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_cean" />

                </Form.Group>
            </Col>
            <Col md={2}>
                <Form.Group className="mb-2">
                    <Form.Label>NCM</Form.Label>
                    <Form.Control type="text" maxLength={8} name="ncm" value={formManifesto.prodPred.ncm}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_ncm" />
                </Form.Group>
            </Col>
            <Col md>
                <Form.Group className="mb-2">
                    <Form.Label>Descrição do produto</Form.Label>
                    <Form.Control type="text" name="xprod" value={formManifesto.prodPred.xprod}
                        onChange={handleProdPred}
                    />
                    <MakeMessageError errors={errors} field="prodPred_xprod" />
                </Form.Group>
            </Col>
        </Row>
    </div>)
}